import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetOpenGameSessions = () => {
    const send = useGenericSend();

    return useCallback(async (options?: Types.IGetOpenGameSessionsRequest): Promise<Types.IGetOpenGameSessionsResponse> => {
        const { data } = await send<Types.IGetOpenGameSessionsRequest, Types.IGetOpenGameSessionsResponse>({
            ID: 36004,
            responses: [36005, 36006],
            description: 'Get open game sessions',
            errorLevel: 1,
            ...options,
            status: options?.status || 'all'
        });

        return data;
    }, [send]);
};
